import React from 'react';
import { RiRuler2Line } from 'react-icons/all';
import useMedia from 'use-media';
import { Cabinet } from '../../lib/modelBuilder/entities/Cabinet';
import { Furniture } from '../../lib/modelBuilder/entities/Furniture';
import { createStructuredSelector } from 'reselect';
import { RootState } from '../PanesPanel/types';
import {
  makeSelectCabinet,
  makeSelectFurniture,
  makeSelectSelectedIdCabinet,
} from '../Configurator/selectors/furniture';
import { makeSelectDisplaySchemaDimension } from '../Configurator/selectors/general';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { displayDimensionAction } from '../Configurator/actions/general';
// import styled from 'styled-components';

interface StateProps {
  displayDimension: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  displayDimension: makeSelectDisplaySchemaDimension(),
});

const SeeSchemaDimensionBtn = () => {
  const { t } = useTranslation();
  const isMobile = useMedia({ maxWidth: 1023 });
  const { displayDimension } = useSelector(stateSelector);
  const dispatch = useDispatch();

  const btnContent = (
    <div className="flex flex-col justify-center items-center px-1">
      {displayDimension ? (
        <div className="text-xl font-semibold text-gray-700">3D</div>
      ) : (
        <RiRuler2Line className="h-8 w-8 text-gray-800" />
      )}
      <div className="text-xs text-gray-800">
        {displayDimension ? t('See in 3D') : t('See dimensions')}
      </div>
    </div>
  );

  if (isMobile) {
    return (
      <button
        className="bg-white border border-gray-300 mt-4"
        onClick={() => {
          if (!displayDimension) dispatch(displayDimensionAction(true));
          else dispatch(displayDimensionAction(false));
        }}
      >
        {btnContent}
      </button>
    );
  } else {
    return btnContent;
  }
};

export default SeeSchemaDimensionBtn;
